var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"flex-end"}},[_c('el-cascader',{attrs:{"placeholder":_vm.addressIds||'请选择地区',"props":_vm.props,"placeholder-style":"color:black!important"},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }